// extracted by mini-css-extract-plugin
export default {"save":"FavoriteButton-module__save__WeiZ5"};